export type HonorariosStatus = 'received' | 'parsed' | 'posted' | 'discarded' | 'error'
export type HonorariosSource = 'email' | 'manual'
export type HonorariosPaymentStatus = 'pending' | 'partial' | 'paid'

/** Etiqueta y color del estado de pago, igual en la lista y en el detalle. */
export const PAYMENT_STATUS_LABEL: Record<HonorariosPaymentStatus, { label: string; variant: 'amber' | 'blue' | 'emerald' }> = {
  pending: { label: 'Pendiente', variant: 'amber' },
  partial: { label: 'Pago parcial', variant: 'blue' },
  paid: { label: 'Pagada', variant: 'emerald' },
}

/** Un abono al líquido. Cada uno tiene su comprobante. */
export interface HonorariosPayment {
  id: string
  amount: string
  payment_date: string
  payment_method: string
  payment_method_display: string | null
  bank_account: string | null
  bank_account_code: string | null
  bank_account_name: string | null
  reference: string
  voucher: string | null
  voucher_number: string | null
  voucher_status: string | null
  created_at: string
}

export interface HonorariosBillListItem {
  id: string
  status: HonorariosStatus
  source: HonorariosSource
  issuer_rut: string
  issuer_name: string
  bhe_number: string
  issue_date: string | null
  total_honorarios: string
  impuesto_honorarios: string
  liquido_honorarios: string
  retiene_emisor: boolean
  voucher: string | null
  payment_status: HonorariosPaymentStatus
  paid_amount: string
  pending_amount: string
  created_at: string
}

export interface HonorariosBillDetail extends HonorariosBillListItem {
  issuer_activity: string
  description: string
  porcentaje_impuesto: string
  codigo_alfa: string
  pdf_file_name: string
  pdf_file_size: number | null
  xml_file_name: string
  received_from_email: string
  received_subject: string
  received_at: string | null
  raw_extraction: Record<string, unknown>
  parse_warnings: string[]
  expense_account: string | null
  expense_account_code: string | null
  expense_account_name: string | null
  voucher_number: string | null
  payment_date: string | null
  payment_method: string
  payment_method_display: string | null
  payment_reference: string
  payment_bank_account: string | null
  payment_bank_account_code: string | null
  payment_bank_account_name: string | null
  payment_voucher: string | null
  payment_voucher_number: string | null
  paid_at: string | null
  payments: HonorariosPayment[]
  reviewed_by: string | null
  reviewed_at: string | null
  updated_at: string
}
